/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import { AddPlus, AddRule, Delete, FinishStepLine, LeftArr, ProfessionalDetails, SecondaryArr, StepLine, Warn } from "../../../../components/common/svg/AllSvg";
import SecondaryBtn from "../../../../components/common/form/SecondaryBtn";
import PrimaryInput from "../../../../components/common/form/PrimaryInput";
import { useEffect, useState } from "react";
import MultiSelect from "../../../../components/common/form/MultiSelect";
import SelectSecondaryComponent from "../../../../components/common/form/SelectSecondaryComponent";
import { components } from "react-select";
import PrimaryTextarea from "../../../../components/common/form/PrimaryTextarea";
import { useFormik } from "formik";
import * as yup from "yup";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import CommonHeader from "../../../../components/common/layout/CommonHeader";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Bounce, ToastContainer } from "react-toastify";
import { errors } from "../../../../shared/utils/errors";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <SecondaryArr />
            </components.DropdownIndicator>
        )
    );
};

const CreateJob = () => {
    const navigate = useNavigate();
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    const [step, setStep] = useState(0);
    const [submit, setSubmit] = useState<boolean>(false);
    const [onlineJob, setOnlineJob] = useState<boolean>(true);
    const [depts, setDepts] = useState<any[]>([]);
    const [locations, setLocations] = useState<any[]>([]);
    const [grades, setGrades] = useState<any[]>([]);
    const [categoryList, setCategoryList] = useState<any[]>([])
    const [typeList, setTypeList] = useState<any[]>([])
    const [qualificationList, setQualificationList] = useState<any[]>([])
    const [opening, setOpening] = useState<any[]>([{
        category: '',
        total_post_available: '',
        category_err: '',
        total_post_available_err: ''
    }])
    const [gradeErr, setGradeErr] = useState<boolean>(false);
    const [ctcErr, setCtcErr] = useState<boolean>(false);
    const [contract, setContract] = useState<boolean>(false);
    const [data, setData] = useState<any>(null)
    const params = useParams();
    const expTypeList: any[] = [
        { value: 'regular', label: t("recruitment.hr.create_job.exp_type.regular") },
        { value: 'contract', label: t("recruitment.hr.create_job.exp_type.contract") },
        { value: 'deputation', label: t("recruitment.hr.create_job.exp_type.deputation") },
    ]
    const salaryTypeList: any[] = [
        { value: 'private', label: t("recruitment.hr.create_job.salary_type.private") },
        { value: 'government', label: t("recruitment.hr.create_job.salary_type.government") },
    ]
    const steps: any[] = [{ name: t("recruitment.hr.create_job.step1"), icon: AddRule }, { name: t("recruitment.hr.create_job.step2"), icon: ProfessionalDetails }]
    const choice: any[] = [{ label: t("recruitment.hr.candidate_detail.yes"), value: true }, { label: t("recruitment.hr.candidate_detail.no"), value: false }]

    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            job_role: !!data?.job_role ? data?.job_role : '',
            deadline: !!data?.deadline ? data?.deadline : '',
            salary_type: !!data?.salary_type ? { label: data?.salary_type === "government" ? t("recruitment.hr.create_job.salary_type.government") : t("recruitment.hr.create_job.salary_type.private"), value: data?.salary_type } : '',
            annual_ctc: !!data?.annual_ctc ? data?.annual_ctc : '',
            mandatory_experience: !!data?.mandatory_experience ? data?.mandatory_experience : '',
            qualification: !!data?.qualification ? data?.qualification : '',
            desirable_experience: !!data?.desirable_experience ? data?.desirable_experience : '',
            advertisement: params?.id,
            location: !!data?.location ? { label: data?.location_details?.name, value: data?.location } : '',
            department: !!data?.department ? { label: data?.department_details?.name, value: data?.department } : '',
            grade_pay: !!data?.grade_pay ? { label: `${data?.grade_pay_details?.grade_code} (${data?.grade_pay_details?.pay_scale})`, value: data?.grade_pay } : '',
            age: !!data?.rule_details?.age ? data?.rule_details?.age : '',
            experience: !!data?.rule_details?.total_experience ? data?.rule_details?.total_experience : '',
            eduqualification: !!data?.rule_details?.qualification_details ? { label: data?.rule_details?.qualification_details?.name, value: data?.rule_details?.qualification_details?.id } : '',
            rule_employment_type: !!data?.rule_details?.employment_type ? { label: data?.rule_details?.employment_type_details, value: data?.rule_details?.employment_type } : '',
            as_on: !!data?.rule_details?.as_of_date ? data?.rule_details?.as_of_date : '',
            employment_nature: (data?.employment_nature?.length > 0 && data?.employment_nature_detail?.length > 0) ? (data?.employment_nature_detail?.map((item: any) => ({ label: item?.title, value: item?.id }))) : '',
            contract_years: !!data?.contract_years ? data?.contract_years : ''
        },
        validationSchema: step === 0 ? yup.object().shape({
            age: yup.number().min(18, t("recruitment.hr.create_job.err.valid_age")).required(t("recruitment.hr.create_job.err.age")),
            experience: yup.number().required(t("recruitment.hr.create_job.err.experience")),
            eduqualification: yup.object(),
            rule_employment_type: yup.object(),
            as_on: yup.date().required(t("recruitment.hr.create_job.err.as_on")),
        }) : yup.object().shape({
            job_role: yup.string().required(t("recruitment.hr.create_job.err.job_role")),
            employment_nature: yup.array().required(t("recruitment.hr.create_job.err.employment_nature")),
            deadline: yup.date().required(t("recruitment.hr.create_job.err.deadline")),
            salary_type: yup.object().required(t("recruitment.hr.create_job.err.salary_type")),
            annual_ctc: yup.number(),
            mandatory_experience: yup.string().required(t("recruitment.hr.create_job.err.mandatory_experience")),
            qualification: yup.string().required(t("recruitment.hr.create_job.err.qualification")),
            desirable_experience: yup.string().required(t("recruitment.hr.create_job.err.desirable_experience")),
            location: yup.object().required(t("recruitment.hr.create_job.err.location")),
            department: yup.object().required(t("recruitment.hr.create_job.err.department")),
            grade_pay: yup.object()
        }),
        onSubmit: async (values: any) => {
            //submit
            if (step === 0) {
                setStep(1)
            } else {
                let totalPost: any = 0;
                const errOpn: any[] = []
                const arr: any[] = []
                for (let i = 0; i < opening?.length; i++) {
                    const el = opening[i];
                    if (!!!el?.category && !!!el.total_post_available) {
                        el.category_err = true
                        el.total_post_available_err = true
                        errOpn.push(el)
                    }

                    if (!!!el?.category) {
                        el.category_err = true
                        errOpn.push(el)
                    }

                    if (!!!el?.total_post_available) {
                        el.total_post_available_err = true
                        errOpn.push(el)
                    }
                    totalPost = totalPost + +el?.total_post_available
                    arr.push({ category_id: el?.category?.value, post_available: el?.total_post_available })
                }

                if (values?.salary_type?.value === "private" && !!!values?.annual_ctc) {
                    setCtcErr(true)
                    return
                }

                if (values?.salary_type?.value === "government" && !!!values?.grade_pay) {
                    setGradeErr(true)
                    return
                }

                if (errOpn?.length > 0) {
                    return
                }

                setSubmit(true)
                try {
                    let obj: any = {
                        ...values,
                        salary_type: values?.salary_type?.value,
                        location: values?.location?.value,
                        department: values?.department?.value,
                        employment_nature: values?.employment_nature?.map((i: any) => i?.value),
                        grade_pay: values?.salary_type?.value === "government" ? values?.grade_pay?.value : null,
                        annual_ctc: values?.salary_type?.value === "private" ? values?.annual_ctc : null,
                        total_post_available: totalPost,
                        post_by_cat: arr,
                        rule_detail: {
                            employment_type: values?.rule_employment_type?.value,
                            age: values?.age,
                            total_experience: values?.experience,
                            qualification: values?.eduqualification?.value,
                            social_category: arr?.map((item: any) => item?.category_id),
                            as_of_date: values?.as_on,
                        },
                        offline: !onlineJob
                    }

                    delete obj["rule_employment_type"]
                    delete obj["age"]
                    delete obj["experience"]
                    delete obj["eduqualification"]
                    delete obj["as_on"]

                    let apiUrl: any = "";
                    if (!!data?.id) {
                        apiUrl = await useAxios.patch(`${(!!lang ? lang : "en") + url?.createJob}${data?.id}/`, obj);
                    } else {
                        apiUrl = await useAxios.post(`${(!!lang ? lang : "en") + url?.createJob}`, obj);
                    }
                    if (!!apiUrl) {
                        const res: any = apiUrl;
                        if (res && (res?.status === 201 || res?.status === 200)) {
                            setSubmit(false)
                            !!params?.lang ? navigate(`/${params?.lang}/admin/ads/${values?.advertisement}`) : navigate(`/admin/ads/${values?.advertisement}`)
                        }
                    }

                } catch (error: any) {
                    setSubmit(false)
                    errors(error)
                    console.error("error while create job", error);
                }
            }
        }
    });

    const getLocation = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.locationList}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setLocations(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching locations", error);
        }
    }

    const getQualification = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.qualificationList}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setQualificationList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching qualification", error);
        }
    }

    const getEmpNature = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.empNature}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setTypeList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching employee nature", error);
        }
    }

    const handleClickAdd = (index: any, e: any, name: any, type: any) => {
        const arr: any[] = [...opening];
        if (name === "category") {
            arr[index]["category_err"] = !!!e ? true : false
        }
        if (name === "total_post_available") {
            arr[index]["total_post_available_err"] = !!!e.target.value ? true : false
        }
        arr[index][name] = type === "input" ? e.target.value : e;

        setOpening(arr);
    }

    const removeInputFields = (index: any) => {
        const rows = [...opening];
        rows.splice(index, 1);
        setOpening(rows);
    }

    const addInputField = () => {
        setOpening([...opening, {
            category: '',
            total_post_available: '',
            category_err: '',
            total_post_available_err: ''
        }])
    }

    const getDept = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.deptList}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setDepts(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching departments", error);
        }
    }

    const getGrade = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.gradeList}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setGrades(res?.data?.results?.map((item: any) => ({ label: `${item?.text} (${item?.pay_scale})`, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching grades", error);
        }
    }

    const getData = async () => {
        try {
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.createJob}${params?.jobId}/`);

            if (res && res.status === 200) {
                setData(res?.data)
                if (res?.data?.post_category_detail?.length > 0) {
                    setOpening(res?.data?.post_category_detail?.map((item: any) => ({
                        category: { label: item?.category, value: item?.category_id },
                        total_post_available: item?.post_available,
                        total_post_available_err: '',
                        category_err: ''
                    })))
                }
            }
        } catch (error) {
            console.error("error while fetching job details", error);
        }
    }

    const getCategory = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.category}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setCategoryList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching category", error);
        }
    }

    useEffect(() => { (!!params?.jobId && !!lang) && getData() }, [params?.jobId, lang])
    useEffect(() => { !!data?.offline && setOnlineJob(data?.offline === true ? false : true) }, [data])

    useEffect(() => {
        if (!!lang) {
            getLocation();
            getDept();
            getGrade();
            getCategory();
            getQualification();
            getEmpNature();
        }
    }, [lang])

    useEffect(() => {
        if (Object?.keys(formik?.errors)?.length === 0) {
            formik.setTouched({});
        }
    }, [formik?.errors, step])

    const handleEType = (e: any) => {
        formik.setFieldValue("employment_nature", e);

        let arr: any = [];
        for (let i = 0; i < e.length; i++) {
            const el = e[i];
            arr.push(el?.label?.toLowerCase())
        }
        if (arr?.includes("contract")) {
            setContract(true)
        } else {
            setContract(false)
        }
    }

    useEffect(() => {
        if (!!formik.values.rule_employment_type) {
            let obj: any = expTypeList?.find((item: any) => formik.values.rule_employment_type?.value === item?.value)
            formik.setFieldValue("rule_employment_type", obj)
        }

        if (!!formik.values.salary_type) {
            let obj: any = salaryTypeList?.find((item: any) => formik.values.salary_type?.value === item?.value)
            formik.setFieldValue("salary_type", obj)
        }
    }, [lang])

    useEffect(() => {
        const handleBeforeUnload = (event: any) => {
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <div className="w-full h-full bg-white dark:bg-bgDarkDull min-h-screen">
            <CommonHeader />

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <div className="w-full container flex items-center justify-center h-full ">
                <div className="w-full lgl:w-[1150px] h-full pt-[30px] lg:pt-[50px]">

                    {/* header title */}
                    <div className="border-b border-[#DADADA] dark:border-[#454545] w-full pb-[20px] flex md:items-center justify-between gap-[15px] md:flex-row flex-col">
                        <div className="flex items-center gap-[4px]">
                            <button aria-label={t("aria_label.back")} title={t("aria_label.back")} className="flex items-center justify-center w-[25px] h-[25px] rounded-full border border-transparent hover:border hover:border-[#ddd] focus:border focus:border-[#ddd] dark:focus:border-[#ffffff5e] dark:hover:border-[#ffffff5e] dark:bg-bgDarkDull bg-white" onClick={() => step === 0 ? navigate(-1) : setStep(0)}>
                                <LeftArr />
                            </button>
                            <h3 className="font-bold text-primaryText dark:text-white">{!!params?.jobId ? t("recruitment.hr.create_job.edit_title") : t("recruitment.hr.create_job.title")}
                            </h3>
                        </div>
                    </div>

                    {/* form */}
                    <div className="grid grid-cols-1 w-full h-full min-h-[calc(100vh-119px)] mms:min-h-[calc(100vh-146px)] lg:min-h-[calc(100vh-166px)] xlx:min-h-[calc(100vh-187px)]">
                        <div className="flex flex-col xsm:flex-row w-full h-full">
                            <div className="w-full xsm:w-[180px] md:w-[226px] xsm:border-r border-[#DADADA] dark:border-[#454545] flex flex-row xsm:flex-col py-[20px] md:py-[25px] xlx:py-[33px] xsm:justify-start justify-between gap-[10px] xsm:gap-0">
                                {Array.isArray(steps) && steps?.map((item: any, index: number) => (
                                    <div key={index} className={`flex items-center gap-[10px] xsm:mb-[87px] ${index !== 1 && "w-full"}`}>
                                        <div className={`min-w-[30px] h-[30px] flex items-center justify-center rounded-full relative ${step >= index ? "bg-[#02C0FC]" : "opacity-[0.7] bg-[#D9D9D9] dark:bg-[#808080]"}`}>
                                            <item.icon className={`${step >= index ? "fill-white" : "fill-blackDull dark:fill-white dark:opacity-[0.7]"}`} />

                                            {index !== 1 && <div className="absolute top-0 left-0 bottom-[-115px] right-0 items-center justify-center xsm:flex hidden">
                                                {step >= index ? <FinishStepLine /> : <StepLine />}
                                            </div>}
                                        </div>

                                        {index !== 1 && <div className={`w-full items-center justify-center xsm:hidden border-b flex ${step >= index ? "border-[#02C0FC]" : "border-[rgba(0,0,0,0.20)]"}`}>
                                        </div>}
                                        <h6 className={`${step >= index ? "text-blackDark dark:text-white" : "text-blackDull text-opacity-[0.5] dark:text-[#ffffff80]"} font-semibold xsm:flex hidden`}>{item?.name}</h6>
                                    </div>
                                ))}
                            </div>

                            <div className="w-full xsm:w-[calc(100%-180px)] md:w-[calc(100%-226px)] h-full">
                                {step === 0 && <div className="py-[15px] xsm:p-[20px] xlx:py-[34px] xlx:px-[48px] flex flex-col gap-[38px]">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px] items-center">
                                        <h5 className="text-blackDull dark:text-textBlackDull font-medium">{t("recruitment.hr.create_job.field.age_title")}</h5>

                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[15px]">
                                            <div className="flex flex-col gap-[4px]">
                                                <PrimaryInput title={`${t("recruitment.hr.create_job.field.age")}*`} name="age" type="number" placeholder={t("recruitment.hr.create_job.placeholder.age")} value={formik?.values?.age} onBlur={formik?.handleBlur} onChange={formik?.handleChange} exceptThisSymbols={["e", "E", "+", "-", "."]} />
                                                {formik?.touched?.age && formik?.errors?.age && <div className="flex gap-[6px] items-start"><Warn />
                                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.age}</span>
                                                </div>}
                                            </div>

                                            <div className="flex flex-col gap-[4px]">
                                                <PrimaryInput title={`${t("recruitment.hr.create_job.field.as_on")}*`} type="date" name="as_on" placeholder={t("recruitment.hr.create_job.field.as_on")} value={formik?.values?.as_on} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                                {formik?.touched?.as_on && formik?.errors?.as_on && <div className="flex gap-[6px] items-start"><Warn />
                                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.as_on}</span>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px] items-center">
                                        <h5 className="text-blackDull dark:text-textBlackDull font-medium items-center">{t("recruitment.hr.create_job.field.exp_title")}</h5>
                                        <div className="flex flex-col gap-[4px]">
                                            <PrimaryInput title={`${t("recruitment.hr.create_job.field.exp")}*`} name="experience" type="number" placeholder={t("recruitment.hr.create_job.field.exp")} value={formik?.values?.experience} onBlur={formik?.handleBlur} onChange={formik?.handleChange} exceptThisSymbols={["e", "E", "+", "-", "."]} />
                                            {formik?.touched?.experience && formik?.errors?.experience && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.experience}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px] items-center">
                                        <h5 className="text-blackDull dark:text-textBlackDull font-medium items-center">{t("recruitment.hr.create_job.field.emp_title")}</h5>
                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.home.job_list.emp")}</h6>
                                            <SelectSecondaryComponent
                                                options={expTypeList}
                                                name="rule_employment_type"
                                                placeholder={t("recruitment.hr.create_job.placeholder.emp")}
                                                isSearchable={false}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => formik.setFieldValue("rule_employment_type", e)}
                                                onBlur={(e: any) => formik.setFieldTouched("rule_employment_type", e)}
                                                value={!!formik.values.rule_employment_type ? expTypeList?.find((item: any) => item?.value === formik.values.rule_employment_type?.value) : formik.values.rule_employment_type}
                                            />

                                            {formik?.touched?.rule_employment_type && formik?.errors?.rule_employment_type && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.rule_employment_type}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px] items-center">
                                        <h5 className="text-blackDull dark:text-textBlackDull font-medium items-center">{t("recruitment.hr.create_job.field.edu_title")}</h5>
                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.hr.create_job.field.edu")}</h6>
                                            <SelectSecondaryComponent
                                                options={qualificationList}
                                                name="eduqualification"
                                                placeholder={t("recruitment.hr.create_job.placeholder.edu")}
                                                isSearchable={false}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => { formik.setFieldValue("eduqualification", e); }}
                                                onBlur={(e: any) => formik.setFieldTouched("eduqualification", e)}
                                                value={!!formik.values.eduqualification ? qualificationList?.find((item: any) => item?.value === formik.values.eduqualification?.value) : formik.values.eduqualification}
                                            />
                                            {formik?.touched?.eduqualification && formik?.errors?.eduqualification && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.eduqualification}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="w-full flex items-end justify-end mt-[20px]">
                                        <SecondaryBtn onClick={formik.handleSubmit} title={!!params?.jobId ? t("recruitment.hr.create_job.edit_job_details") : t("recruitment.hr.create_job.add_job_details")} css="px-[18px] font-semibold rounded-[6px] text-sm leading-snug uppercase" />
                                    </div>
                                </div>}


                                {step === 1 && <div className="py-[15px] xsm:p-[20px] xlx:py-[34px] xlx:px-[48px] flex flex-col gap-[15px]">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px]">
                                        <div className="flex flex-col gap-[4px]">
                                            <PrimaryInput title={`${t("recruitment.hr.create_job.field.job_role")}*`} name="job_role" type="text" placeholder={t("recruitment.hr.create_job.field.job_role")} value={formik?.values?.job_role} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                            {formik?.touched?.job_role && formik?.errors?.job_role && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.job_role}</span>
                                            </div>}
                                        </div>

                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.dept")}*`}</h6>
                                            <SelectSecondaryComponent
                                                options={depts}
                                                name="department"
                                                placeholder={t("recruitment.hr.create_job.placeholder.dept")}
                                                isSearchable={false}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => formik.setFieldValue("department", e)}
                                                onBlur={(e: any) => formik.setFieldTouched("department", e)}
                                                value={!!formik.values.department ? depts?.find((item: any) => item?.value === formik.values.department?.value) : formik.values.department}
                                            />
                                            {formik?.touched?.department && formik?.errors?.department && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.department}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                        <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.hr.create_job.field.exp_other")}</h5>
                                        <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                    </div>


                                    <div className="grid w-full grid-cols-1 md:grid-cols-2 msm:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.home.job_list.emp")}*`}</h6>
                                            <MultiSelect
                                                options={typeList}
                                                name="employment_nature"
                                                placeholder={t("recruitment.hr.create_job.placeholder.emp")}
                                                isSearchable={true}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => handleEType(e)}
                                                onBlur={(e: any) => formik.setFieldTouched("employment_nature", e)}
                                                value={formik.values.employment_nature}
                                                type="select"
                                                isMulti={true}
                                            />
                                            {formik?.touched?.employment_nature && formik?.errors?.employment_nature && <div className="flex gap-[6px]"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.employment_nature}</span>
                                            </div>}
                                        </div>

                                        {contract && <div className="flex flex-col gap-[4px]">
                                            <PrimaryInput title={t("recruitment.hr.create_job.field.years")} type="number" name="contract_years" placeholder={t("recruitment.hr.create_job.field.years")} exceptThisSymbols={["e", "E", "+", "-", "."]} value={formik?.values?.contract_years} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                            {formik?.touched?.contract_years && formik?.errors?.contract_years && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.contract_years}</span>
                                            </div>}
                                        </div>}
                                    </div>

                                    <div className="grid w-full grid-cols-1 md:grid-cols-2 msm:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.salary_type")}*`}</h6>
                                            <SelectSecondaryComponent
                                                options={salaryTypeList}
                                                name="salary_type"
                                                placeholder={t("recruitment.hr.create_job.placeholder.salary_type")}
                                                isSearchable={false}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => formik.setFieldValue("salary_type", e)}
                                                onBlur={(e: any) => formik.setFieldTouched("salary_type", e)}
                                                value={formik.values.salary_type}
                                            />

                                            {formik?.touched?.salary_type && formik?.errors?.salary_type && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.salary_type}</span>
                                            </div>}
                                        </div>

                                        {formik.values.salary_type?.value === "government" &&
                                            <div className="flex flex-col gap-[4px]">
                                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.pay_scale")}*`}</h6>
                                                <SelectSecondaryComponent
                                                    options={grades}
                                                    name="grade_pay"
                                                    placeholder={t("recruitment.hr.create_job.placeholder.pay_scale")}
                                                    isSearchable={false}
                                                    arrow={true}
                                                    components={{ DropdownIndicator }}
                                                    onChange={(e: any) => { formik.setFieldValue("grade_pay", e); !!e ? setGradeErr(false) : setGradeErr(true) }}
                                                    onBlur={(e: any) => formik.setFieldTouched("grade_pay", e)}
                                                    value={!!formik.values.grade_pay ? grades?.find((item: any) => item?.value === formik.values.grade_pay?.value) : formik.values.grade_pay}
                                                />

                                                {!!gradeErr && <div className="flex gap-[6px] items-start"><Warn />
                                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.hr.create_job.err.pay_scale")}</span>
                                                </div>}
                                            </div>}

                                        {formik.values.salary_type?.value === "private" && <div className="flex flex-col gap-[4px]">
                                            <PrimaryInput title={`${t("recruitment.hr.create_job.field.ctc")}*`} type="number" name="annual_ctc" placeholder={t("recruitment.hr.create_job.field.ctc")} exceptThisSymbols={["e", "E", "+", "-", "."]} value={formik?.values?.annual_ctc} onBlur={formik?.handleBlur} onChange={(e: any) => { formik?.handleChange(e); !!e.target.value ? setCtcErr(false) : setCtcErr(true) }} />
                                            {!!ctcErr && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.hr.create_job.err.ctc")}</span>
                                            </div>}
                                        </div>
                                        }
                                    </div>

                                    <div className="grid w-full grid-cols-1 md:grid-cols-2 msm:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                        <div className="flex flex-col gap-[4px]">
                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.location")}*`}</h6>
                                            <SelectSecondaryComponent
                                                options={locations}
                                                name="location"
                                                placeholder={t("recruitment.hr.create_job.placeholder.location")}
                                                isSearchable={false}
                                                arrow={true}
                                                components={{ DropdownIndicator }}
                                                onChange={(e: any) => formik.setFieldValue("location", e)}
                                                onBlur={(e: any) => formik.setFieldTouched("location", e)}
                                                value={!!formik.values.location ? locations?.find((item: any) => item?.value === formik.values.location?.value) : formik.values.location}
                                            />

                                            {formik?.touched?.location && formik?.errors?.location && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.location}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                        <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.hr.create_job.field.job_opening")}</h5>
                                        <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                    </div>

                                    {Array.isArray(opening) && opening.map((item: any, index: number) => (
                                        <div className="grid w-full grid-cols-1 md:grid-cols-2 msm:grid-cols-3 gap-[15px] xlx:gap-[20px] items-start" key={index}>
                                            <div className="flex flex-col gap-[4px]">
                                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.category")}*`}</h6>
                                                <SelectSecondaryComponent
                                                    options={categoryList}
                                                    name="category"
                                                    placeholder={t("recruitment.hr.create_job.placeholder.category")}
                                                    isSearchable={false}
                                                    arrow={true}
                                                    components={{ DropdownIndicator }}
                                                    value={!!item?.category ? categoryList?.find((i: any) => i?.value === item?.category?.value) : item?.category} onChange={(e: any) => { handleClickAdd(index, e, "category", "select"); }}
                                                />

                                                {!!item?.category_err && <div className="flex gap-[6px] items-start"><Warn />
                                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.hr.create_job.err.category")}</span>
                                                </div>}
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <PrimaryInput title={`${t("recruitment.hr.create_job.field.no_of_post")}*`} type="number" name="total_post_available" placeholder={t("recruitment.hr.create_job.field.no_of_post")} exceptThisSymbols={["e", "E", "+", "-", "."]} value={item?.total_post_available} onChange={(e: any) => { handleClickAdd(index, e, "total_post_available", "input"); }} />
                                                {!!item?.total_post_available_err && <div className="flex gap-[6px] items-start"><Warn />
                                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.hr.create_job.err.no_of_post")}</span>
                                                </div>}
                                            </div>

                                            <div className="flex items-center gap-[15px] xlx:gap-[20px] mt-[20px] xlx:mt-[22px]">
                                                {(opening.length > 1 && opening.length !== (index + 1)) && <button className="min-w-[35px] xlx:min-w-[40px] h-[35px] xlx:h-[40px] flex items-center justify-center bg-[#D9D9D9] rounded-[4px] bg-opacity-[0.4] focus:shadow-[0_0_0_2px_#FF00005e] hover:shadow-[0_0_0_2px_#FF00005e]" onClick={() => removeInputFields(index)} aria-label={t("aria_label.delete")} title={t("aria_label.delete")}><Delete /> </button>}

                                                {(opening.length === 1 || opening.length === (index + 1)) && <SecondaryBtn title={t("recruitment.hr.create_job.field.add_more")} css="px-[11px] font-medium rounded-[6px] text-sm leading-snug !gap-[8px]" leftIcon={<AddPlus />} onClick={addInputField} disabled={(!!item?.category && !!item?.total_post_available && !!!item?.category_err && !!!item?.total_post_available_err) ? false : true} />}
                                            </div>
                                        </div>
                                    ))}


                                    <div className="flex flex-col gap-[4px]">
                                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.create_job.field.online")}`}</h6>
                                        <div className="flex items-center gap-[10px]">
                                            {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                                                <button key={index} className={`${(onlineJob === item?.value) ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:shadow-none disabled:dark:shadow-none disabled:opacity-[0.7]`} onClick={() => setOnlineJob(!onlineJob)}>{item?.label}</button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                        <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.hr.create_job.field.criteria")}</h5>
                                        <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                    </div>

                                    <div className="grid w-full grid-cols-1 md:grid-cols-2 msm:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                        <div className="flex flex-col gap-[4px]">
                                            <PrimaryInput title={`${t("recruitment.hr.create_job.field.deadline")}*`} type="date" name="deadline" placeholder={t("recruitment.hr.create_job.field.deadline")} value={formik?.values?.deadline} onBlur={formik?.handleBlur} onChange={formik?.handleChange} min={new Date().toISOString().split("T")[0]} />
                                            {formik?.touched?.deadline && formik?.errors?.deadline && <div className="flex gap-[6px] items-start"><Warn />
                                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.deadline}</span>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                        <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.hr.create_job.field.write_desc")}</h5>
                                        <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                    </div>

                                    <div className="flex flex-col gap-[4px]">
                                        <PrimaryTextarea title={`${t("recruitment.hr.create_job.field.man_exp")}*`} placeholder={t("recruitment.hr.create_job.field.man_exp")} rows="4" name="mandatory_experience" value={formik?.values?.mandatory_experience} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                        {formik?.touched?.mandatory_experience && formik?.errors?.mandatory_experience && <div className="flex gap-[6px] items-start"><Warn />
                                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.mandatory_experience}</span>
                                        </div>}
                                    </div>

                                    <div className="flex flex-col gap-[4px]">
                                        <PrimaryTextarea title={`${t("recruitment.hr.create_job.field.qualification")}*`} placeholder={t("recruitment.hr.create_job.field.qualification")} rows="4" name="qualification" value={formik?.values?.qualification} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                        {formik?.touched?.qualification && formik?.errors?.qualification && <div className="flex gap-[6px] items-start"><Warn />
                                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.qualification}</span>
                                        </div>}
                                    </div>

                                    <div className="flex flex-col gap-[4px]">
                                        <PrimaryTextarea title={`${t("recruitment.hr.create_job.field.desirable_experience")}*`} placeholder={t("recruitment.hr.create_job.field.desirable_experience")} rows="4" name="desirable_experience" value={formik?.values?.desirable_experience} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                        {formik?.touched?.desirable_experience && formik?.errors?.desirable_experience && <div className="flex gap-[6px] items-start"><Warn />
                                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.desirable_experience}</span>
                                        </div>}
                                    </div>

                                    <div className="w-full flex items-end justify-end mt-[20px] xlx:mt-[30px]">
                                        <SecondaryBtn disabled={submit} onClick={formik.handleSubmit} title={t("recruitment.hr.create_ad.field.save")} css="px-[24px] lg:px-[30px] xlx:px-[42px] font-semibold rounded-[6px] text-sm leading-snug uppercase" />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateJob;